import { useUtilityContext } from '@change-corgi/core/react/utilityContext';

import { usePsfPromoteOrSharePageData } from 'src/app/pages/psf/promoteOrShare/pageContext';
import { useCookiePref } from 'src/app/shared/hooks/session';

export function useSetBanditsCookie() {
	const cookiesPreference = useCookiePref('preferences');
	const { cookies } = useUtilityContext();
	const {
		data: {
			bandits: { psfCombo },
		},
	} = usePsfPromoteOrSharePageData();

	return function setPsfComboBanditsCookie(): void {
		const cookieValue = cookies.get('psf_combo_bandit_r7');
		// Set the cookie for the PSF Combo Bandit R7 experiment variant
		if (!cookieValue && cookiesPreference && psfCombo.comboExpVariant) {
			cookies.set('psf_combo_bandit_r7', psfCombo.comboExpVariant, {
				expires: new Date(Date.now() + 1000 * 60 * 60 * 24 * 5), // 5 days
			});
		}
	};
}
